import React, { useEffect, useState, useMemo } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate, Redirect } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  InputGroup,
  InputGroupText,
  FormGroup,
  Label,
  UncontrolledTooltip,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap"
import Select from "react-select"
import classnames from "classnames"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

import {
  Pdate,
  Type,
  Value,
  ValueinUSD,
  Status,
  Coin,
  Tracked,
} from "./userstabledata"

import TableContainer from "../../components/Common/TableContainer"

// import img2 from "../../assets/images/no-time-off.59f54e64.svg"

//Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"

// import { cryptoOrderData } from "../../../common/data";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCryptoOrders } from "store/crypto/actions"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { post } from "helpers/api_helper"
import axios from "axios"
import DeleteModal from "components/Common/DeleteModal"
import apiURl from "url"

const AppUsers = props => {
  // Meta title
  document.title = "ECS App Users"
  const navigate = useNavigate()

  // Authorization check
  const role_ = localStorage.getItem("role")
  if (role_ !== "admin") {
    navigate("/")
  }

  // State management
  const [orders, setOrders] = useState([])
  const [modal, setModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  // Fetch users data
  const getAllUsers = async () => {
    try {
      setIsLoading(true)
      const URL = `${apiURl}/getAllUsers`
      const response = await axios.get(URL)

      if (response.data.status === "success") {
        setOrders(response.data.users)
        console.log(response.data.users)
      } else {
        console.error("Failed to fetch users:", response.data.message)
      }
    } catch (error) {
      console.error("Error fetching users:", error)
    } finally {
      setIsLoading(false)
    }
  }

  // Initialize component
  useEffect(() => {
    getAllUsers()
  }, [])

  // Toggle modal and set selected user
  const toggleModal = (user = null) => {
    setSelectedUser(user)
    setModal(!modal)
  }

  // Table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        disableFilters: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Name",
        accessor: "name",
        disableFilters: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Phone",
        accessor: "phone",
        disableFilters: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "CNIC",
        accessor: "cnic",
        disableFilters: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      //   {
      //     Header: "Status",
      //     accessor: "status",
      //     disableFilters: true,
      //     Cell: ({ value }) => (
      //       <span
      //         className={`badge ${
      //           value === "verified" ? "bg-success" : "bg-warning"
      //         }`}
      //       >
      //         {value}
      //       </span>
      //     ),
      //   },
      {
        Header: "Created Date",
        accessor: "created_date",
        disableFilters: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: "Actions",
        accessor: "actions",
        disableFilters: true,
        Cell: ({ row }) => (
          <button
            className="btn btn-primary btn-sm"
            onClick={() => toggleModal(row.original)}
          >
            View Details
          </button>
        ),
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="6">
              <h5 className="mt-2">App Users Management</h5>
            </Col>
          </Row>

          <Row className="pt-3">
            <Col lg="12">
              <Card>
                <CardBody>
                  {isLoading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: "200px" }}
                    >
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={orders}
                      isGlobalFilter={true}
                      customPageSize={10}
                      className="custom-table"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Modal for user details */}
        <Modal isOpen={modal} toggle={toggleModal} centered>
          <ModalHeader toggle={toggleModal}>User Details</ModalHeader>
          <ModalBody>
            {selectedUser && (
              <div>
                <p>
                  <strong>ID:</strong> {selectedUser.id}
                </p>
                <p>
                  <strong>Name:</strong> {selectedUser.name}
                </p>
                <p>
                  <strong>Email:</strong> {selectedUser.email}
                </p>
                <p>
                  <strong>Phone:</strong> {selectedUser.phone}
                </p>
                <p>
                  <strong>CNIC:</strong> {selectedUser.cnic}
                </p>
                <p>
                  <strong>Status:</strong> {selectedUser.status}
                </p>

                <p>
                  <strong>Created Date:</strong> {selectedUser.created_date}
                </p>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default AppUsers
